import CryptoJS from "crypto-js";

export const formatCreatedOn = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0"); // Get day and add leading zero if needed
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
  const year = date.getFullYear(); // Get full year

  return `${day}/${month}/${year}`;
};

export const encryptData = (inputText) => {
  const secretKey = CryptoJS.enc.Utf8.parse("SimpleSecretKey1"); // Needs to be 16 bytes exactly for AES-128

  try {
    const encrypted = CryptoJS.AES.encrypt(inputText, secretKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7, // PKCS5Padding is essentially PKCS7 for AES's 16-byte blocks
    }).toString();
    return encrypted;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
